module.exports = __webpack_public_path__ + "img/01-11.14f45b5c.png";